import { Box, Button, Tab, Tabs, Typography } from '@mui/material'
import Table from './Table'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { setBookExtractPage } from '../../actions/rule'
import { useState } from 'react'
import RuleGraph from './RuleGraph'

interface AnalyzedCodeViewProps {}

const AnalyzedCodeView: React.FC<AnalyzedCodeViewProps> = () => {
  const [selectedTab, setSelectedTab] = useState<string>('Table')
  const dispatch = useDispatch<any>()
  const codeRules = useSelector((state: RootState) => state.rule.codeRules)
  const tableData = codeRules?.table_output?.rules || []
  const graphOutput = codeRules?.graph_output || {}
  const graphData = { ...(codeRules?.code_data || {}), ...graphOutput }
  const selectedRule = useSelector(
    (state: RootState) => state.rule.selectedRule,
  )
  const handleTabChange = (e: any, value: string) => {
    setSelectedTab(value)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        width: '100%',
        overflowY: 'scroll',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Button
          variant='text'
          disableRipple
          onClick={() => dispatch(setBookExtractPage('EXTRACT_CODE'))}
          sx={{
            justifyContent: 'left',
            textTransform: 'none',
            color: '#04002E',
            p: 1,
          }}
        >
          {'< Back'}
        </Button>
        <Typography
          sx={{
            color: '#04002E',

            fontSize: '28px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          {'Analyzed Code Review'}
        </Typography>
        <Typography
          sx={{
            color: '#04002E',

            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          All highlighted text will be extracted. Feel free to manually
          highlight text to add to the extraction process.
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <Typography
            sx={{
              color: '#04002E',

              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}
          >
            {'Code'}
          </Typography>
          <Typography
            sx={{
              color: '#04002E',

              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            {selectedRule?.content}
          </Typography>
        </Box>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={handleTabChange}>
              <Tab label='Table' value='Table' />
              <Tab label='Graph' value='Graph' />
            </Tabs>
          </Box>
        </Box>
        {selectedTab === 'Table' && <Table rows={tableData} />}
        {selectedTab === 'Graph' && <RuleGraph data={graphData} />}
      </Box>
    </Box>
  )
}

export default AnalyzedCodeView
